import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";
import { SavedReportId } from "../../shared/schema/schema";

export default createQueryGroup(({ api }) => ({
  scheduledHistory: (savedReportId: SavedReportId) =>
    queryOptions({
      queryKey: ["scheduledReports", "saved", savedReportId, "history"],
      queryFn: () =>
        api.get("./saved_report/:savedReportId/scheduled_history", {
          path: { savedReportId },
        }),
      select: ({ list }) => list,
    }),

  standardScheduledHistory: (standardReportId: number) =>
    queryOptions({
      queryKey: ["scheduledReports", "standard", standardReportId, "history"],
      queryFn: () =>
        api.get("./standard_reports/:standardReportId/scheduled_history", {
          path: { standardReportId },
        }),
      select: ({ list }) => list,
    }),
}));
